<template>
    <div class="modal is-active">
        <div class="modal-background" @click.stop="$emit('close')" />
        <div class="modal-card" @click.stop>
            <header
                :class="{ 'is-paddingless': fullwidthHeader }"
                class="modal-card-head is-block"
            >
                <slot name="header" />
            </header>
            <section class="modal-card-body">
                <slot name="body" />
            </section>
            <footer class="modal-card-foot">
                <slot name="footer" />
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        fullwidthHeader: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {};
    },
    computed: {},
    methods: {},
};
</script>

<style scoped>
.modal.is-active.is-transparent .modal-card-head,
.modal.is-active.is-transparent .modal-card-body,
.modal.is-active.is-transparent .modal-card-foot {
    background: transparent;
}
.modal.is-active.is-transparent .modal-card-body::-webkit-scrollbar {
    display: none;
}
.modal.is-active.is-transparent .modal-card-body {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.modal.is-active.is-headless .modal-card-head {
    display: none !important;
}
.modal.is-active.is-footless .modal-card-foot {
    display: none !important;
}
.modal.is-active.is-full-height .modal-card {
    max-height: 100% !important;
}
</style>
